var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.media)?_c('button',{staticClass:"btn btn-success",on:{"click":_vm.downloadFile}},[_c('i',{staticClass:"fas fas fa-download"}),_vm._v(" "+_vm._s(_vm.media.name)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }